<template>
  <div>
    <NuxtPage />
    <!--
      Mounted app-wide, outside NuxtPage, because each of these needs to outlive
      something that would otherwise unmount it: the mobile slide-out menu closing
      (FeatureAnnouncementModalContainer and TutorialsPanel are opened by rows that live
      inside it) or a route change (WalkthroughController, when a step navigates).
    -->
    <FeatureAnnouncementModalContainer v-if="isFeatureAnnouncementEnabled" />
    <WalkthroughController v-if="isFeatureAnnouncementEnabled" />
    <TutorialsPanel v-if="isTutorialsEnabled" />
    <TutorialsStaticModal v-if="isTutorialsEnabled" />
  </div>
</template>

<script setup>
// Same gate the What's New nav entry and panel use, so one entry point can never appear
// without the other.
const { isFeatureAnnouncementEnabled } = useIsFeatureAnnouncementEnabled();
const { isTutorialsEnabled } = useIsTutorialsEnabled();
</script>
